import React, { useEffect, useState } from 'react'
import { Dialog, Button, TextField, Grid, Typography } from '@mui/material'
import CircularProgress from '@mui/material/CircularProgress'
import { Auth } from 'aws-amplify'
import QRCode from 'qrcode.react'

const inputLabelProps = {
  classes: {
    shrink: 'text-black font-bold',
    focused: 'text-primary',
  },
}

const SetupMFADialog = ({ open, onClose, onSuccess, user, qrCode }) => {
  const [loading, setLoading] = useState(false)
  const [code, setCode] = useState('')
  const [error, setError] = useState('')

  useEffect(() => {
    setCode('')
  }, [open])

  const handleVerifyClick = async () => {
    if (loading || !code) return
    setLoading(true)
    setError('')
    try {
      await Auth.verifyTotpToken(user, code)
      onSuccess()
    } catch (error) {
      if (error.message === 'Your software token has already been used once.') {
        onSuccess()
        return
      }
      setError(error.message)
    } finally {
      setLoading(false)
    }
  }

  return (
    <Dialog maxWidth="xs" open={open} onClose={onClose}>
      <h4 className="capitalize m-0 mb-4">
        Setup Multi-factor authentication
      </h4>

      <Grid container spacing={2}>
        <Grid item sm={12} className="flex justify-center">
          {qrCode && <QRCode value={qrCode} size={200} />}
        </Grid>
        <Grid item sm={12}>
          <Typography style={{ fontWeight: 'bold' }} align="center">
            Scan the QR Code with any TOTP generation app such as Google
            Authenticator & enter the temporary code below to complete the MFA
            registration.
          </Typography>
        </Grid>

        <Grid item sm={12}>
          <TextField
            autoFocus
            label={'Code'}
            value={code}
            onChange={(event) => {
              if (error) setError('')
              setCode(event.target.value)
            }}
            InputLabelProps={inputLabelProps}
            variant="outlined"
            size="small"
            error={!!error}
            helperText={error}
            fullWidth
            onKeyPress={(event) => {
              if (event.key === 'Enter') handleVerifyClick()
            }}
          />
        </Grid>
      </Grid>
      <div className="flex justify-start pt-2 m--2">
        <Button
          className="m-2 rounded hover-bg-primary px-6"
          variant="outlined"
          color="primary"
          disabled={loading || !code}
          onClick={handleVerifyClick}
          startIcon={loading ? <CircularProgress size={16} /> : null}
        >
          Verify
        </Button>
        <Button
          className="m-2 rounded hover-bg-error px-6"
          variant="outlined"
          onClick={onClose}
        >
          Cancel
        </Button>
      </div>
    </Dialog>
  )
}

export default SetupMFADialog
